export type FoamMusicCue = "intro" | "gameplay" | "danger";

export interface FoamMusicTrack {
  cue: FoamMusicCue;
  title: string;
  author: string;
  path: string;
  sourceUrl: string;
  license: "CC0-1.0";
  sha256: string;
  volume: number;
}

export const FOAM_POP_MUSIC_TRACKS: Readonly<Record<FoamMusicCue, FoamMusicTrack>> = Object.freeze({
  intro: Object.freeze({
    cue: "intro",
    title: "8Bit Title Screen",
    author: "Joth",
    path: "/assets/foam-pop/v1/audio/intro-title-screen.mp3",
    sourceUrl: "https://opengameart.org/content/8bit-title-screen",
    license: "CC0-1.0",
    sha256: "0fd7f99ae046278959645889f9bb0970a0430381ee1bd2e7a68c5f41438b29d8",
    volume: 0.24
  }),
  gameplay: Object.freeze({
    cue: "gameplay",
    title: "Happy Adventure (Loop)",
    author: "TinyWorlds",
    path: "/assets/foam-pop/v1/audio/gameplay-happy-adventure.mp3",
    sourceUrl: "https://opengameart.org/content/happy-adventure-loop",
    license: "CC0-1.0",
    sha256: "50aa6a32625fe8565403a0c8ceb772d7fb500b9267d0019eacfe0fc742b6c73d",
    volume: 0.21
  }),
  danger: Object.freeze({
    cue: "danger",
    title: "Chip Bit Danger",
    author: "Sudocolon",
    path: "/assets/foam-pop/v1/audio/danger-chip-bit-danger.mp3",
    sourceUrl: "https://opengameart.org/content/chip-bit-danger",
    license: "CC0-1.0",
    sha256: "6656f7ee749dfcb060effcd9ce73da6be9d3006cd189463bc7e7429f2ccf600f",
    volume: 0.16
  })
});

export const FOAM_POP_MUSIC_STORAGE_KEY = "foam-pop:music-muted:v1";

